import React, { useEffect, useState } from "react";
import { useProvider, Toast } from "../context/MenuProvider";
import { Spinner, Button } from "react-bootstrap";
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Markdown from '../components/Utils/Markdown';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");


const ApnItem = ({ consultor }) => {
  const [expandido, setExpandido] = useState(false);
  const [nextDownUrl, setNextDownUrl] = useState(null);
  const [dados, setDados] = useState(consultor); // manter estado local
  const { crudAdmin } = useProvider();
  const { loading, patch } = crudAdmin || {};

  const toggleAtivar = async () => {
    try {
      Swal.fire({
        title: "Fez pré cadastro?",
        text: `${consultor?.contato?.nome_do_cliente || consultor?.nome} já fez pré cadastro?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try {
            const response = await patch({ pre_cadastro: true }, `/rede/apn/${dados.id}/`, null, 'salvar');
            if (response  && response.length) {
              setDados((prev) => ({ ...prev, ...response[0] }));
              Toast.fire({
                icon: "success",
                title: `Salvo com sucesso`
              });
            }
          } catch (err) {
            console.error("Erro ao ativar consultor:", err);
          }
        }
      });
    } catch (err) {
      console.error("Erro ao ativar consultor", err);
    }
  };
  
  const toggleExpand = async () => {
    setExpandido(!expandido);
  };
  
  const handleWhatsApp = async () => {
    const whats = dados?.telefone?.replace(/\D/g, '');
    if(!whats) return;
    const mensagem = encodeURIComponent(`Oi ${dados?.nome?.trim().split(' ')[0]}`);
    const url = `whatsapp://send?phone=+55${whats}&text=${mensagem}`;
    window.open(url);
  };
  
  return (
    <div className="mb-2 list-group-item list-group-item-action">
      <div className="d-flex justify-content-between align-items-center">
        <Link 
          to={`/rede/apn/${dados.id}/editar`} 
          className={`text-decoration-none ${!dados?.pre_cadastro ? "text-danger" : ""}`}
        >
          {!dados?.pre_cadastro && "(Recusou) "}
          {dados?.nome}
        </Link>
        
        <div>
          <Button
            variant="outline-primary"
            className="btn btn-sm ms-2"
            onClick={toggleExpand}
          >
            {expandido 
              ? <i className="bx bx-chevron-up"></i> 
              : <i className="bx bx-chevron-down"></i>}
          </Button>
        </div>
      </div>
      {expandido && (
        <div className="border-top mt-1 pt-1">
          {dados?.upline && (<div>Apn para Downline {dados.upline?.nome}</div>)}
          <Markdown texto={dados?.observacoes} />
          {dados?.telefone && (<>
            <div className="text-center">
              <Button
                size="sm"
                variant="outline-success"
                onClick={handleWhatsApp}
              >
                <i className="bx bxl-whatsapp"></i> {dados?.telefone}
              </Button>
            </div>
          </>)}
        </div>
      )}
    </div>
  );
};

const Apn = () => {
  const { crudAdmin } = useProvider();
  const { get, loading } = crudAdmin || {};
  const [apns, setApns] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);

  const buscarApns = async (url = `/rede/apn/?ordering=-data,nome&expand=contato,upline`) => {
    try {
      const response = await get(url, "pagina");
      if (response && response[0]?.results) {
        setApns((prev) => [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      }
    } catch (err) {
      console.error("Erro ao buscar apns:", err);
    }
  };

  useEffect(() => {
    buscarApns();
  }, []);

  // Scroll infinito para os apns raiz
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        if (!loading && nextUrl) buscarApns(nextUrl);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);
  
  const groupedApns = apns.reduce((acc, apn) => {
    const data = apn.data;
    if (!acc[data]) acc[data] = [];
    acc[data].push(apn);
    return acc;
  }, {});

  return (
    <div className="list-group">
      {!loading && apns.length === 0 && (
        <p className="text-center text-muted">Nenhuma apresentação encontrada.</p>
      )}
      <BotaoFlutuante to="/rede/apn/novo" icon="bi-plus"></BotaoFlutuante>
      <div>
        {Object.keys(groupedApns).map((data) => (
          <div key={data}>
            <div className="fs-6 mt-3 text-muted">{dayjs(data).format("DD/MM/YYYY dddd")}</div>
            {groupedApns[data].map((c) => (
              <ApnItem key={c.id} consultor={c} />
            ))}
          </div>
        ))}
      </div>
      {loading && <p className="text-center"><Spinner animation="border" /></p>}
    </div>
  );
};

export default Apn;